export default "__VITE_ASSET__DOoq8Z59__"